import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import { getJobRoles, createJobRole, updateJobRole, deleteJobRole } from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import Grid from "../Common/Grid";
import { showSuccessToastMessage, showErrorToastMessage } from "../../../../utilities";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import AdminBreadcrumb from "../Common/Breadcrumb";
import { emptyCheck } from "../../../../utilities";
import RequiredField from "../Common/RequiredField";

class AdminJobRoles extends Component {
  state = {
    jobrolegroupName: "",
    masterjobroles: [],
    jobroles: [],
    selectedJobRole: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: ""
  };
  componentDidMount() {
    this.getJobRolesFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  getJobRolesFromService() {
    this.showSpinner(true);
    getJobRoles(this.props.match.params.id)
      .then(response => {
        this.showSpinner(false);
        this.setState({ jobroles: response.data, masterjobroles: response.data });
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }

  editJobRole(state) {
    this.setState({
      action: "edit",
      selectedJobRole: state,
      showModal: true,
      modalTitle: "Edit JobRole",
      errorMessage: ""
    });
  }

  deleteJobRole(state) {
    this.setState({
      action: "delete",
      selectedJobRole: state,
      modalDeleteTitle: "Delete JobRole",
      showDeleteModal: true
    });
  }
  addJobRole() {
    this.setState({
      action: "add",
      selectedJobRole: {},
      showModal: true,
      modalTitle: "Add JobRole",
      errorMessage: ""
    });
  }
  onHideModal() {
    this.setState({
      showModal: false
    });
  }

  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "JobRole");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }
  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }
  saveJobRole() {
    const data = {
      JobRoleGroupId: this.props.match.params.id,
      Id: this.state.action === "edit" ? this.state.selectedJobRole.Id : 0,
      Name: this.refs["txtJobRole"].value
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createJobRole(data)
            .then(response => {
              this.showSpinner(false);
              console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getJobRolesFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateJobRole(data)
            .then(response => {
              this.showSpinner(false);
              console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getJobRolesFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteJobRole() {
    this.showSpinner(true);
    deleteJobRole(this.state.selectedJobRole.Id)
      .then(response => {
        this.showSpinner(false);
        console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedJobRole.Name);
        this.getJobRolesFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleJobRoleChange = event => {
    let selectedJobRole = this.state.selectedJobRole;
    selectedJobRole.Name = event.target.value;
    this.setState({ selectedJobRole: selectedJobRole });
  };

  handleSearchTermChange = event => {
    let filteredJobRoles = this.state.masterjobroles.filter(d => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        jobroles: filteredJobRoles,
        searchTerm: event.target.value
      });
    else
      this.setState({
        jobroles: this.state.masterjobroles,
        searchTerm: event.target.value
      });
  };

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">
          Job Roles
          {this.state.jobroles.length > 0 ? ` - ${this.state.jobroles[0].JobRoleGroupName}` : ""}
        </h1>
        <AdminBreadcrumb
          data={[
            { name: "Home", link: "/admin/modules/" },
            { name: "Job Role Groups", link: "/admin/jobrolegroups/" },
            { name: "Job Roles" }
          ]}
        />
        <button className="btn btn-default add-btn" onClick={() => this.addJobRole()}>
          Add Job Role
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Name"]}
          values={this.state.jobroles}
          indexName="Id"
          properties={["Id", "Name", "Action"]}
          edit={value => this.editJobRole(value)}
          delete={value => this.deleteJobRole(value)}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveJobRole()}
          form={this.addeditform}
          type="Job Role"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />Name:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtJobRole"
              defaultValue={this.state.selectedJobRole.Name}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedJobRole.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          modalTitle={this.state.modalDeleteTitle}
          confirm={() => this.confirmDeleteJobRole()}
          name={this.state.selectedJobRole.Name}
          type="Job Role"
        />
      </Aux>
    );
  }
}

export default AdminJobRoles;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/JobRoles/JobRoles.js